import Typography from '@mui/material/Typography';
import { ViewRoot, ViewContent, ViewContentCenter, ViewSidebar } from '../../layout/Main/styled';
import { useNavigate, useLocation } from 'react-router-dom';
import { ActionsRoot, CardGridStyled, LinkStyled, TriagemCard, TriagemActionButton } from './styled';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import { enabledBackButtonOnSchedulePage, saveCurrentStep } from '../../features/stepper/stepper-slice';
import ButtonNeed from '../../components/ButtonNeed';
import { INeed, useGetNeedsMutation } from '../../services/needs.service';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { persistor } from '../..';
import { dynamicCustomEventTracking } from '../../lib/gtm';

const NeedList = () => {
  const [getNeedsMutation, { data, isLoading }] = useGetNeedsMutation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [cameFromInternalPage, setCameFromInternalPage] = useState(false);
  const cameFromDirectAccess =
    !document.referrer.includes(window.location.origin) && !location.state?.fromInternalNavigation;

  const openTriagem = () => {
    dynamicCustomEventTracking.send({ dynamicEventName: `chat_support_click_ag` });
    navigate('/assistente-virtual');
  };

  useEffect(() => {
    persistor.purge();
    getNeedsMutation('');
    dispatch(saveCurrentStep('NeedList'));
    dispatch(enabledBackButtonOnSchedulePage(true));
  }, []);

  useEffect(() => {
    setCameFromInternalPage(location.state?.fromInternalNavigation);
  }, [cameFromDirectAccess, location.state]);
  return (
    <>
      <ViewRoot>
        <ViewContent className="ViewContent">
          <ViewContentCenter>
            <Box mb={3}>
              <Box mb={3}>
                <Typography variant="h3">Estou interessada em...</Typography>
              </Box>
              {!isLoading ? <></> : <CircularProgress sx={{ color: 'brand.darkGreen' }} />}
              <CardGridStyled>
                {data?.supportChatEnabled && (
                  <TriagemCard key="triagem">
                    <TriagemActionButton
                      variant="contained"
                      color="primary"
                      onClick={openTriagem}
                      startIcon={<AutoAwesomeOutlinedIcon />}
                    >
                      Falar com assistente virtual
                    </TriagemActionButton>
                    <Typography variant="body2R" color="neutrals.lead">
                      Dúvidas? Converse com nossa assistente e receba uma indicação personalizada!
                    </Typography>
                  </TriagemCard>
                )}

                {data?.need
                  ?.filter((need: INeed) => !need.disable)
                  .map((value: INeed) => {
                    return (
                      <Box key={value.name} sx={{ mb: { xs: 2, md: 1 } }}>
                        <LinkStyled target="_self" onClick={() => navigate(`/selecao-de-servicos/${value.route}`)}>
                          <ButtonNeed title={value.name} />
                        </LinkStyled>
                      </Box>
                    );
                  })}
              </CardGridStyled>
            </Box>
            {cameFromInternalPage && (
              <ActionsRoot mb={5} mt={3}>
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{ padding: '12px 24px 14px 16px' }}
                  onClick={() => navigate(-1)}
                >
                  <ArrowBackIcon />
                  <Typography variant="body1" sx={{ ml: 1.5 }}>
                    Voltar
                  </Typography>
                </Button>
              </ActionsRoot>
            )}
          </ViewContentCenter>
        </ViewContent>
        <ViewSidebar withimage="true" component="aside" className="ViewSidebar">
          <Typography color="neutrals.beige1" variant="h1">
            O que você precisa hoje?
          </Typography>
        </ViewSidebar>
      </ViewRoot>
    </>
  );
};

export default NeedList;
